export default __webpack_public_path__ + "static/media/check (2).124edcdc.svg";